import { styled, StyledText } from '@clickcease/cc-client-components-lib'

export const ModalDescription = styled(StyledText, {
  display: 'block',
  marginBottom: '$10',
})
